// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3WZZf","title":"Info_title__3sb1Q","selects":"Info_selects__3itVw","requiredAsterisk":"Info_requiredAsterisk__O42-D"};